module.exports = __webpack_public_path__ + "static/media/sponsors-mobile-062823.a68d480f.png";